import React, { Fragment } from 'react';
import { Button } from '@mui/joy';
import { useSettings } from "@context";
import { maxeleImperialStyle, maxwvelImperialKnotsStyle, swanImperialStyle } from "@utils";

/**
 * component that handles the removal of styles from
 * local storage ADCIRC raster layers
 *
 * @returns React.ReactElement
 * @constructor
 */
export const ResetStyles = () => {
    const styles = [
        'maxele',
        'maxwvel',
        'swan',
    ];

    const { setChangesMade, mapStyle, unitsType, speedType } = useSettings();

    /**
     * remove the raster layer styles from local storage
     */
    function removeStyles() {
       styles.forEach((style) => window.localStorage.removeItem(style));
       
       // set units back to default values
       unitsType.set("imperial");
       speedType.set("knots");
       // set all styles back to default values
       mapStyle.maxele.set(maxeleImperialStyle);
       mapStyle.maxwvel.set(maxwvelImperialKnotsStyle);
       mapStyle.swan.set(swanImperialStyle);

       setChangesMade(true);
    }

    // render the button
    return (
        <Fragment>
            <Button color="primary" onClick={() => removeStyles()}>Reset ADCIRC Layers Colormaps</Button>
        </Fragment>
  );
};
